import { memo } from 'react';
import { NodeProps } from 'reactflow';
import { BaseNode } from './BaseNode';

/** Bloco "Sequência": inscreve o contato numa sequência de mensagens */
export const SequenceEnrollNode = memo((props: NodeProps) => (
  <BaseNode
    {...props}
    description={props.data.config?.sequenceName ? `Inscrever em: ${props.data.config.sequenceName}` : 'Escolha a sequência'}
    onDelete={props.data.onDelete}
  />
));

SequenceEnrollNode.displayName = 'SequenceEnrollNode';
